import {
  all,
  call,
  CallEffect,
  fork,
  put,
  PutEffect,
  takeEvery,
} from 'redux-saga/effects';
import { fetchNewsSuccess, fetchNewsByIdSuccess } from '../actions';
import { ActionTypes } from '../../constants/ActionTypes';
import { ShowError } from '../../helper/Alert';
import FaraGostarDynamicHttp from '../../api/FaraGostarDynamicHttp';
import { AxiosResponse } from 'axios';

// recent news
const getNews = async () => {
  const http = await FaraGostarDynamicHttp();
  return await http.get('announcement/get');
};

const getNewsById = async (announcementId: string) => {
  const http = await FaraGostarDynamicHttp();
  return await http.get(`announcement/GetNews?id=${announcementId}`);
};

function* fetchNewsRequest(): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  try {
    const fetchedNews = yield call(getNews);
    yield put(fetchNewsSuccess(fetchedNews.data));
  } catch (error) {
    return ShowError('', error);
  }
}

export function* fetchNews() {
  yield takeEvery(ActionTypes.GET_NEWS, fetchNewsRequest);
}

// For New Details
function* fetchNewsByIdRequest(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  try {
    const fetchedNewsById = yield call(getNewsById, action.payload);
    yield put(fetchNewsByIdSuccess(fetchedNewsById.data));
  } catch (error) {
    return ShowError('', error);
  }
}

export function* fetchNewsById() {
  yield takeEvery(ActionTypes.GET_NEWS_BY_ID, fetchNewsByIdRequest);
}

export default function* rootSaga() {
  yield all([fork(fetchNews), fork(fetchNewsById)]);
}
